import { toast } from 'react-toastify'
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import { formatError } from '../error'

/**
 * React Query setting client
 *
 * More info: https://tanstack.com/query/latest/docs/framework/react/guides/important-defaults
 *
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: (failureCount, err) => {
        const { status } = formatError(err)
        if (failureCount === 1 || status === 401 || status === 403 || status === 406) {
          return false
        }
        return true // allow retry max 1 time
      },
    },
  },
  queryCache: new QueryCache({
    onError: (err: any) => {
      const status = err.status
      if (status === 502) {
        // TODO
      }
      console.error('react query error', err)
      toast.error(formatError(err).message)
    },
  }),
})

export const ReactQueryProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} buttonPosition='bottom-left' />
    </QueryClientProvider>
  )
}
